<template>
  <div>
    <div class="section-header text-center text-md-start mb-2 mb-md-0">
      Alti conducatori
    </div>
    <div class="mb-4 text-center text-md-start">
      Mai incluzi pe cineva in lista, ca persoane admise la conducere?
      <br />
      Daca una din persoanele admise la conducere nu a figurat in vreun contract RCA dupa anul 2013, s-ar putea ca pretul asigurarii sa se majoreze.
    </div>
    <div
      v-for="(driver, index) in moreDrivers"
      :key="driver.id"
      class="mb-3"
    >
      <div :id="driver.id">
        <one-more-driver
          :current-data="driver"
          :el-index="index + 1"
          @removeDriver="removeDriver"
          @updateData="updateDriver"
        />
      </div>
    </div>
    <div v-if="moreDrivers.length < 2" class="d-flex justify-center">
      <v-btn
        color="#2B3A47"
        class="base-button"
        depressed
        tile
        dark
        large
        @click="addDriver"
      >
        Adauga conducator
        <v-icon right>
          mdi-plus
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import OneMoreDriver from '@/components/rca/OneMoreDriver';
export default {
  name: 'MoreDriversForm',
  components: { OneMoreDriver },
  data() {
    return {
      showMoreDrivers: false,
      moreDrivers: []
    };
  },
  methods: {
    scrollTo(sectionId) {
      setTimeout(() => {
        this.$scrollTo(
          sectionId,
          400,
          {
            offset: -180
          });
      }, 400);
    },
    getUniqueId() {
      return '_' + Math.random().toString(36).substring(2, 10);
    },
    addDriver() {
      if (this.moreDrivers.length < 2) {
        const currentId = this.getUniqueId();
        this.moreDrivers.push({
          id: currentId,
          info: [],
          isValid: false
        });
        this.updateEvent();
        this.scrollTo(`#${currentId}`);
      }
    },
    removeDriver(driverId) {
      this.moreDrivers = this.moreDrivers.filter(el => el.id !== driverId);
      this.updateEvent();
    },
    updateDriver({ driverId, data, isValid }) {
      this.moreDrivers = this.moreDrivers.map((el) => {
        if (el.id === driverId) {
          el.info = JSON.parse(JSON.stringify(data));
          el.isValid = isValid;
        }
        return el;
      });
      this.updateEvent();
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateData', {
          data: JSON.parse(JSON.stringify(this.moreDrivers)),
          isValid: !this.moreDrivers.find(el => !el.isValid)
        });
      });
    }
  },
};
</script>

<style scoped>
.section-header {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
}
</style>
